<div class="header">
  <div class="title">Merge Contacts</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<form [formGroup]="form">
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto">
      <mat-label>Merge Contact</mat-label>
      <input matInput placeholder="Search..." [matAutocomplete]="auto" [formControlName]="'targetContact'" />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedContact($event)">
        <ng-container *ngIf="contactSearchResults$ | async as contactSearchResults">
          <mat-option *ngFor="let contact of contactSearchResults" [value]="contact">
            {{ contact.name }}
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto">
      <mat-label>Into Contact</mat-label>
      <input matInput disabled readonly [value]="destinationContact.name" />
    </mat-form-field>
  </div>
  <div class="merge-hint" *ngIf="sourceContact">
    <p>
      1: All associations with Merge Contact (<span>{{ sourceContact.name }}</span
      >) will be replaced with the Into Contact (<span>{{ destinationContact.name }}</span
      >).
    </p>
    <p>
      2: The Merge Contact (<span>{{ sourceContact.name }}</span
      >) will be deleted.
    </p>
  </div>
  <div class="actions">
    <button class="discard-button" mat-button type="button" (click)="discard()">
      <span>Cancel</span>
    </button>
    <button
      class="send-button"
      mat-flat-button
      type="submit"
      [color]="'primary'"
      [disabled]="form.pristine || form.invalid || !sourceContact?.id"
      (click)="saveAndClose()"
    >
      <span>Merge</span>
    </button>
  </div>
</form>
